module.exports = __webpack_public_path__ + "static/media/3.df8f7584.png";